/*
 * @Description: 审批单相关接口
 */
import { RootObject } from '@/model/rootObject'
import https from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  ApprovalFormPageParamModel, ApprovalFormHistoryPageParamModel,
  ApprovalFormCreateModel, ApprovalFormCancelModel, ApprovalFormCancelAllModel,
  ApprovalFormRejectModel, ApprovalFormRejectAllModel, ApprovalFormPageModel, ApprovalFormDetailModel,
  ApprovalPaymentHistoryModel
} from '@/model/process/approvalModel'

const baseUrl = '/base/approval'

export const createApprovalForm = (createInfo: ApprovalFormCreateModel) => {
  return https().request<RootObject<number>>(baseUrl + '/create', Method.POST, createInfo, ContentType.json)
}

export const getApprovalFormDetailById = (id: string) => {
  return https().request<RootObject<ApprovalFormDetailModel>>(baseUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getApprovalHistoryDetailById = (id: string) => {
  return https().request<RootObject<ApprovalPaymentHistoryModel[]>>(baseUrl + '/approval/history/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getApprovalFormPageList = (params: ApprovalFormPageParamModel) => {
  return https().request<RootObject<ApprovalFormPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getApprovalFormPageListByUser = (params: ApprovalFormPageParamModel) => {
  return https().request<RootObject<ApprovalFormPageModel>>(baseUrl + '/listByUser', Method.POST, params, ContentType.json)
}

export const getApprovalFormHistoryPageList = (params: ApprovalFormHistoryPageParamModel) => {
  return https().request<RootObject<ApprovalFormPageModel>>(baseUrl + '/list/history', Method.POST, params, ContentType.json)
}

export const cancelSelectPayment = (params: ApprovalFormCancelModel) => {
  return https().request<RootObject<number>>(baseUrl + '/cancel/select', Method.POST, params, ContentType.json)
}

export const rejectSelectPayment = (params: ApprovalFormRejectModel) => {
  return https().request<RootObject<number>>(baseUrl + '/reject/select', Method.POST, params, ContentType.json)
}

export const cancelAllPayment = (params: ApprovalFormCancelAllModel) => {
  return https().request<RootObject<number>>(baseUrl + '/cancel/all', Method.POST, params, ContentType.json)
}

export const rejectAllPayment = (params: ApprovalFormRejectAllModel) => {
  return https().request<RootObject<number>>(baseUrl + '/reject/all', Method.POST, params, ContentType.json)
}

export const submitPayment = (id: number) => {
  return https().request<RootObject<number>>(baseUrl + '/submit/' + id, Method.POST, undefined, ContentType.json)
}

export const approved = (id: number) => {
  return https().request<RootObject<number>>(baseUrl + '/approved/' + id, Method.POST, undefined, ContentType.json)
}
